import { Injectable } from '@angular/core';
import { NotificationsListener } from '@/app/platform/platform-core/platform-notifications/listeners/notifications-listener';

@Injectable({
  providedIn: 'root'
})
export class PlatformNotificationsInitializer {
  constructor(private readonly listener: NotificationsListener) {
  }
  async init() {
    await this.listener.init();
  }
}
